import React from "react";

export const TagLine = (props) => {
  return (
    <section id="tagline" className="container">
      <div className="container">
        <div className="col-xs-12 col-md-6">
          <p>Olemme Uudellamaalla pieniä pintaremontteja tarjoava yritys.<br></br>Olipa kyseessä pieni pintaremontti tai suunnittelupulma, me hoidamme sen ammattitaidolla<br></br>ja suurella sydämellä. Meille ei ole olemassa liian pientä pintaremonttia.</p>
        </div>
      </div>
    </section>
  )
}